// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wiggleCart":"_9G3Y5","shake":"TLXuZ"};